import styled from 'styled-components';
import { EColors } from 'styles/style-variables/colors';
import { FontFamily } from 'styles/style-variables/font-family';

export const TransactionsList = styled.table`
  display: flex;
  flex-grow: 1;
`;

export const TransactionType = styled.td`
  padding: 8px 0;
  white-space: nowrap;
`;

export const TransactionDate = styled.td`
  padding: 8px 16px;
  font-family: ${FontFamily.Montserrat};
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
  letter-spacing: 0.5px;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
  color: ${EColors.Gray2};
  font-variant-numeric: lining-nums tabular-nums;
`;

export const TransactionMessage = styled.td`
  padding: 8px 0;
  font-family: ${FontFamily.Montserrat};
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 18px;
  white-space: wrap;
  color: ${EColors.Gray1Text};
  font-variant-numeric: lining-nums tabular-nums;
`;
